
(function () {
  'use strict';
 
  var HT = window.HT || {};
  var routes = HT.routes || {};
  var CART_URL = (routes.cart || '/cart');
  var ADD_URL = (routes.cartAdd || '/cart/add') + '.js';
  var CHANGE_URL = (routes.cartChange || '/cart/change') + '.js';
  var FREE_SHIP = Number(HT.freeShip) || 0;
 
  function money(cents) { return '$' + (Math.round(cents) / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function sizedImg(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
 
  /* ---------------- Cart API ---------------- */
  function getCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Something went wrong. Try again.');
        return d;
      });
    });
  }
 
  /* ---------------- Drawer ---------------- */
  var drawer = document.querySelector('[data-ht-drawer]');
  var lastFocus = null;
 
  function openDrawer() {
    if (!drawer) { window.location.href = CART_URL; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('ht-lock');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      drawer.querySelector('.ht-drawer__panel').focus();
    });
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('ht-lock');
    setTimeout(function () { drawer.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
 
  function renderCart(cart) {
    document.querySelectorAll('[data-ht-count]').forEach(function (el) { el.textContent = cart.item_count; });
    if (!drawer) return;
 
    var lines = drawer.querySelector('[data-ht-lines]');
    if (!cart.item_count) {
      lines.innerHTML = '<p class="ht-drawer__empty">Your cart is empty. Go pick a flavor.</p>';
    } else {
      lines.innerHTML = cart.items.map(function (it, i) {
        var props = '';
        if (it.properties) {
          Object.keys(it.properties).forEach(function (k) {
            var v = it.properties[k];
            if (v && k.charAt(0) !== '_') props += '<span>' + esc(k) + ': ' + esc(v) + '</span>';
          });
        }
        var disc = (it.line_level_discount_allocations || []).map(function (d) {
          return '<div class="ht-line__disc">' + esc(d.discount_application && d.discount_application.title) + '</div>';
        }).join('');
        var img = it.image ? '<img src="' + esc(sizedImg(it.image, 160)) + '" alt="" width="80" height="80" loading="lazy">' : '';
        var line = i + 1;
        var planName = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? it.selling_plan_allocation.selling_plan.name : '';
        var parts = String(it.product_title || '').split(/\s+[-–—|]\s+/);
        var titleMain = parts[0];
        var titleSub = parts.slice(1).join(' ');
        return '<div class="ht-line">' +
          '<div class="ht-line__img">' + img + '</div>' +
          '<div class="ht-line__info">' +
            '<a class="ht-line__title" href="' + esc(it.url) + '">' + esc(titleMain) + '</a>' +
            (titleSub ? '<span class="ht-line__sub">' + esc(titleSub) + '</span>' : '') +
            (props ? '<div class="ht-line__props">' + props + '</div>' : '') +
            (planName ? '<div class="ht-line__disc">' + esc(planName) + '</div>' : '') +
            disc +
            '<div class="ht-qty">' +
              '<button type="button" data-ht-line="' + line + '" data-ht-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity of ' + esc(it.product_title) + '">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-ht-line="' + line + '" data-ht-q="' + (it.quantity + 1) + '" aria-label="Increase quantity of ' + esc(it.product_title) + '">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="ht-line__price">' +
            (it.original_line_price !== it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') +
            '<span>' + money(it.final_line_price) + '</span>' +
          '</div>' +
        '</div>';
      }).join('');
    }
 
    drawer.querySelector('[data-ht-subtotal]').textContent = money(cart.total_price);
    drawer.querySelector('[data-ht-savings]').textContent = cart.total_discount > 0 ? 'You save ' + money(cart.total_discount) : '';
 
    var ship = drawer.querySelector('[data-ht-ship]');
    if (FREE_SHIP > 0 && ship) {
      var left = FREE_SHIP - cart.total_price;
      var pct = Math.max(0, Math.min(100, (cart.total_price / FREE_SHIP) * 100));
      ship.classList.toggle('is-done', left <= 0);
      ship.querySelector('[data-ht-ship-msg]').textContent = left <= 0
        ? 'Free shipping unlocked'
        : money(left) + ' away from free shipping';
      ship.querySelector('[data-ht-ship-fill]').style.width = pct + '%';
    } else if (ship) {
      ship.hidden = true;
    }
    drawer.querySelector('.ht-drawer__foot').hidden = !cart.item_count;
 
    /* Creatine upsell: show when there's a tub but no creatine */
    var up = drawer.querySelector('[data-ht-upsell]');
    if (up) {
      var creId = up.getAttribute('data-variant');
      var creHandle = up.getAttribute('data-handle');
      var hasCre = cart.items.some(function (it) { return String(it.variant_id) === creId || it.handle === creHandle; });
      var hasTub = cart.items.some(function (it) {
        var t = String(it.product_title || '');
        return /electrolyte|hydration/i.test(t) && !/care|pack|bundle/i.test(t);
      });
      up.hidden = !(hasTub && !hasCre);
    }
  }
 
  function refresh() { return getCart().then(function (c) { renderCart(c); return c; }); }
 
  function addItems(items, btn, statusEl) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    if (statusEl) { statusEl.hidden = true; statusEl.textContent = ''; }
    return postJSON(ADD_URL, { items: items })
      .then(refresh)
      .then(openDrawer)
      .catch(function (err) {
        if (statusEl) { statusEl.textContent = err.message; statusEl.hidden = false; }
      })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  }
  HT.addItems = addItems;
 
  /* Cart button: caught in the capture phase so other scripts/apps can't hijack it */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-ht-cart-open]');
    if (!opener) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!drawer) { window.location.href = opener.getAttribute('data-cart-url') || CART_URL; return; }
    openDrawer();
    refresh();
  }, true);
 
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ht-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    var upBtn = e.target.closest('[data-ht-upsell-add]');
    if (upBtn) {
      var upBox = upBtn.closest('[data-ht-upsell]');
      addItems([{ id: Number(upBox.getAttribute('data-variant')), quantity: 1 }], upBtn, null);
      return;
    }
    var q = e.target.closest('[data-ht-line]');
    if (q) {
      q.disabled = true;
      postJSON(CHANGE_URL, { line: Number(q.getAttribute('data-ht-line')), quantity: Math.max(0, Number(q.getAttribute('data-ht-q'))) })
        .then(renderCart)
        .catch(function () { refresh(); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
    if (e.key === 'Tab' && drawer && !drawer.hidden) {
      var f = drawer.querySelectorAll('a[href],button:not([disabled]),select,input');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
 
  /* ---------------- Stack & Save picker ---------------- */
  function initStack(sec) {
    var disc = (sec.getAttribute('data-disc') || '0,0,0,0').split(',').map(Number);
    var flavors = Array.prototype.slice.call(sec.querySelectorAll('.ht-flavor[data-variant]'));
    var tiers = Array.prototype.slice.call(sec.querySelectorAll('.ht-tier'));
    var ptypes = Array.prototype.slice.call(sec.querySelectorAll('[data-ht-ptype]'));
    var subBtn = sec.querySelector('[data-ht-ptype="sub"]');
    var subBadge = sec.querySelector('[data-ht-sub-badge]');
    var btn = sec.querySelector('[data-ht-stack-add]');
    var per = sec.querySelector('[data-ht-pertub]');
    var status = sec.querySelector('[data-ht-status]');
    if (!btn) return;
 
    var f = flavors.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; })[0] || flavors[0];
    var tOn = tiers.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; })[0] || tiers[0];
    var q = tOn ? Number(tOn.getAttribute('data-qty')) : 1;
    var pOn = ptypes.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; })[0];
    var mode = pOn ? pOn.getAttribute('data-ht-ptype') : 'once';
 
    function press(list, el) { list.forEach(function (x) { x.setAttribute('aria-pressed', x === el ? 'true' : 'false'); }); }
    if (f) press(flavors, f);
 
    function update() {
      if (!f) { btn.disabled = true; btn.textContent = 'Connect products in theme editor'; return; }
      var p = Number(f.getAttribute('data-price'));
      var plan = f.getAttribute('data-plan');
      var planPrice = Number(f.getAttribute('data-plan-price')) || 0;
      var canSub = !!(plan && planPrice);
 
      if (subBtn) {
        subBtn.disabled = !canSub;
        if (subBadge) subBadge.textContent = canSub && planPrice < p ? 'Save ' + Math.round((1 - planPrice / p) * 100) + '%' : '';
      }
      var sub = mode === 'sub' && canSub;
      if (mode === 'sub' && !canSub && ptypes.length) { mode = 'once'; press(ptypes, sec.querySelector('[data-ht-ptype="once"]')); }
 
      /* Subscriptions are 1 tub at a time: lock quantity to 1, dim 2-4 */
      if (sub && q !== 1) { q = 1; press(tiers, tiers.filter(function (t) { return t.getAttribute('data-qty') === '1'; })[0]); }
      tiers.forEach(function (t) {
        var locked = sub && t.getAttribute('data-qty') !== '1';
        t.style.opacity = locked ? '.38' : '';
        t.title = locked ? 'Subscriptions are 1 tub per month. Tap to switch to one-time.' : '';
      });
 
      tiers.forEach(function (t) {
        var n = Number(t.getAttribute('data-qty'));
        var price, save;
        if (sub && n === 1) { price = planPrice; save = p - planPrice; }
        else { save = disc[n - 1] || 0; price = p * n - save; }
        t.querySelector('[data-tier-price]').textContent = money(price) + (sub && n === 1 ? '/mo' : '');
        t.querySelector('[data-tier-save]').textContent = save > 0 ? 'Save ' + money(save) : 'Single';
      });
 
      var total = sub ? planPrice * q : p * q - (disc[q - 1] || 0);
      var ok = f.getAttribute('data-available') === 'true';
      btn.disabled = !ok;
      if (!ok) btn.textContent = 'Sold out';
      else if (sub) btn.textContent = 'Subscribe · 1 tub — ' + money(total) + '/mo';
      else btn.textContent = 'Add ' + q + (q === 1 ? ' tub' : ' tubs') + ' — ' + money(total);
      if (per) per.textContent = f.getAttribute('data-name') + ' · ' + money(total / q) + ' per tub' + (sub ? ' · ships monthly' : '');
    }
 
    flavors.forEach(function (x) { x.addEventListener('click', function () { f = x; press(flavors, x); update(); }); });
    tiers.forEach(function (x) {
      x.addEventListener('click', function () {
        q = Number(x.getAttribute('data-qty'));
        /* picking 2-4 tubs while subscribed switches back to one-time */
        if (q > 1 && mode === 'sub') { mode = 'once'; press(ptypes, sec.querySelector('[data-ht-ptype="once"]')); }
        press(tiers, x);
        update();
      });
    });
    ptypes.forEach(function (x) { x.addEventListener('click', function () { if (x.disabled) return; mode = x.getAttribute('data-ht-ptype'); press(ptypes, x); update(); }); });
    btn.addEventListener('click', function () {
      if (!f) return;
      var item = { id: Number(f.getAttribute('data-variant')), quantity: q };
      var plan = f.getAttribute('data-plan');
      if (mode === 'sub' && plan) item.selling_plan = Number(plan);
      addItems([item], btn, status).then(update);
    });
    update();
  }
 
  /* ---------------- Bundle forms ---------------- */
  function initBundleForm(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = [];
      form.querySelectorAll('[data-line]').forEach(function (el) {
        if (el.value) items.push({ id: Number(el.value), quantity: 1 });
      });
      if (!items.length) return;
      var props = {};
      form.querySelectorAll('[data-prop]').forEach(function (el) { if (el.value) props[el.getAttribute('data-prop')] = el.value; });
      if (Object.keys(props).length) items[0].properties = props;
      addItems(items, form.querySelector('[type="submit"]'), form.querySelector('[data-ht-status]'));
    });
  }
 
  /* ---------------- Product page ---------------- */
  function initProductForm(form) {
    var sel = form.querySelector('[data-ht-variant]');
    var priceBox = document.querySelector('[data-ht-price]');
    var btn = form.querySelector('[type="submit"]');
    if (sel) {
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        if (priceBox) {
          var html = '<span class="ht-price__now">' + esc(o.getAttribute('data-price')) + '</span>';
          if (o.getAttribute('data-compare')) {
            html += '<span><s class="ht-price__was">' + esc(o.getAttribute('data-compare')) + '</s><span class="ht-price__save">Save ' + esc(o.getAttribute('data-save')) + '</span></span>';
          }
          priceBox.innerHTML = html;
        }
        var avail = o.getAttribute('data-available') === 'true';
        btn.disabled = !avail;
        btn.textContent = avail ? 'Add to cart' : 'Sold out';
        var url = new URL(window.location.href);
        url.searchParams.set('variant', o.value);
        window.history.replaceState({}, '', url.toString());
      });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      addItems([{ id: Number(fd.get('id')), quantity: Math.max(1, Number(fd.get('quantity')) || 1) }], btn, form.querySelector('[data-ht-status]'));
    });
  }
 
  function initGallery(g) {
    var main = g.querySelector('.ht-pdp__main img');
    g.querySelectorAll('[data-ht-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = b.getAttribute('data-ht-thumb');
        g.querySelectorAll('[data-ht-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });
  }
 
  function init() {
    document.querySelectorAll('[data-ht-stack]').forEach(initStack);
    document.querySelectorAll('[data-ht-bundle]').forEach(initBundleForm);
    document.querySelectorAll('.ht-pform').forEach(initProductForm);
    document.querySelectorAll('[data-ht-gallery]').forEach(initGallery);
  }
 
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
 
  /* Re-init sections when changed in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ht-stack]').forEach(initStack);
    e.target.querySelectorAll('[data-ht-bundle]').forEach(initBundleForm);
  });
})();
 
